{
  "title": {
    "show": true,
    "textStyle": {
      "color": "#666666",
      "fontSize": 12,
      "fontWeight": "normal"
    },
    "text": "No data to display",
    "left": "center",
    "top": "center"
  },
  "backgroundColor": "transparent",
  "xAxis": {
    "show": false
  },
  "yAxis": {
    "show": false
  },
  "series": []
}
